import axios from './axios';

export default {
  create(internshipIds, sessionId) {
    return axios.post('/registrations', { internship_ids: internshipIds, session_id: sessionId });
  },
};
